/**
 * @param {String} [value] input value
 * @returns {Boolean}
 */
export const shouldRenderSuggestions = (value) => !!value.trim().length;

/**
 * @param {SuggestionsSection} section
 * @returns {Array<Suggestion>}
 */
export const getSectionSuggestions = ({ items }) => items;

/**
 * @param {Suggestion} suggestion
 * @returns {String}
 */
export const getSuggestionTitle = ({ matched }) => matched;
